import { createAction, createSlice, PrepareAction } from '@reduxjs/toolkit';
import { persistUser, readUser } from '@app/services/localStorage.service';
import { UserProfile } from '@app/api/admin';

// 权限接口定义
export interface UserPermission {
  resource: string;
  action: string;
  permission: string; // 格式: "resource:action"
}

export interface UserState {
  user: UserProfile | null;
  permissions: UserPermission[]; // 新增权限数组
  roles: string[]; // 新增角色数组
  permissionsLoaded: boolean; // 权限是否已加载
}

const initialState: UserState = {
  user: readUser(),
  permissions: [],
  roles: [],
  permissionsLoaded: false,
};

export const setUser = createAction<PrepareAction<UserProfile>>('user/setUser', (newUser) => {
  persistUser(newUser);

  return {
    payload: newUser,
  };
});

// 新增设置权限的action
export const setUserPermissions = createAction<UserPermission[]>('user/setUserPermissions');
export const setUserRoles = createAction<string[]>('user/setUserRoles');
export const setPermissionsLoaded = createAction<boolean>('user/setPermissionsLoaded');

// 清除权限数据的action
export const clearUserPermissions = createAction('user/clearUserPermissions');

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setUser, (state, action) => {
        state.user = action.payload;
      })
      .addCase(setUserPermissions, (state, action) => {
        state.permissions = action.payload;
      })
      .addCase(setUserRoles, (state, action) => {
        state.roles = action.payload;
      })
      .addCase(setPermissionsLoaded, (state, action) => {
        state.permissionsLoaded = action.payload;
      })
      .addCase(clearUserPermissions, (state) => {
        state.permissions = [];
        state.roles = [];
        state.permissionsLoaded = false;
      });
  },
});

export default userSlice.reducer;
